import ForumModule from './containers/forumModule'

export {default as ForumModuleLayout} from './components/forumModuleLayout'

export default ForumModule
